var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 504.8 504.8",
    style: {
      enableBackground: "new 0 0 504.8 504.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M251.3,89.5c-5.9,0-10.6,4.8-10.6,10.6v158.6l114.9,88.4c1.9,1.5,4.2,2.2,6.5,2.2c3.2,0,6.4-1.4,8.4-4.2 c3.6-4.7,2.7-11.3-1.9-14.9l-106.6-82V100.1C262,94.2,257.2,89.5,251.3,89.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.4,0C113.2,0,0,113.2,0,252.4c0,55.8,17.8,108.5,51.5,152.7L9.3,437.9c-4.2,3.3-2.4,10,2.9,10.6l102.7,12.9 c3.3,0.4,6.2-1.9,6.7-5.2l12.9-102.7c0.7-5.3-5.4-8.7-9.6-5.4L75,386.8c-29.6-38.9-45.2-85.3-45.2-134.4 c0-122.7,99.9-222.6,222.6-222.6S475,129.7,475,252.4S375.1,475,252.4,475c-8.2,0-14.9,6.7-14.9,14.9c0,8.2,6.7,14.9,14.9,14.9 c139.2,0,252.4-113.2,252.4-252.4S391.6,0,252.4,0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryIcon);
export default __webpack_public_path__ + "static/media/history_icon.068e8b9474ca452ad443e2e45c0a080c.svg";
export { ForwardRef as ReactComponent };